module.exports = __webpack_public_path__ + "img/img_32389_0_158.ae532da7.png";